<template>
  <div>
    <LayoutTelaFiltros
      :titulo="this.$route.meta.titulo"
      :registros="listaUsuarios"
      :camposTabela="retornaCamposTabela()"
      ordenarPor="nome"
      :totalPaginas="totalDePaginas"
      :isLoading="isLoading"
      @buscarTodos="buscarTodos"
      @buscaFiltro="buscaFiltro"
      @clicouItemTabela="clicouItemTabela"
      @limpar="limpar"
    />

    <fab
      :position="floatButton.position"
      :bg-color="floatButton.bgColor"
      :fixed-tooltip="true"
      :actions="floatButton.fabActions"
      :start-opened="true"
      @cadastroUsuario="cadastroUsuario"
    />
  </div>
</template>

<script>
import fab from 'vue-fab'
import LayoutTelaFiltros from '@/components/layouts/LayoutTelaFiltros.vue'
import GeradorMensagens from '@/mixins/GeradorMensagens'

import UsuarioService from '../../services/usuarios.service'

const botaoFlutuante = {
  bgColor: '#003149',
  position: 'bottom-right',
  fabActions: [
    {
      name: 'cadastroUsuario',
      icon: 'person_add',
      tooltip: 'Cadastrar usuários',
    },
  ],
}

export default {
  name: 'Usuarios',
  components: {
    LayoutTelaFiltros,
    fab,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      listaUsuarios: [],
      totalDePaginas: 0,
      floatButton: botaoFlutuante,
      isLoading: false,
    }
  },
  created() {
    this.buscarTodos()
  },
  methods: {
    async buscarTodos(pagina = 0) {
      this.mostrarLoader()
      try {
        const usuarios = await UsuarioService.retornaTodos(pagina)
        this.listaUsuarios = usuarios.lista.filter(usuario => !usuario.esconder)
        this.totalDePaginas = usuarios.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    async buscaFiltro(filtro, pagina = 0) {
      this.mostrarLoader()
      try {
        const usuarios = await UsuarioService.retornaTodosPorFiltro(filtro, pagina)
        this.listaUsuarios = usuarios.lista
        this.totalDePaginas = usuarios.pages
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    clicouItemTabela(item) {
      this.$router.push({
        name: 'rota-usuarios-alteracao',
        params: { id: item._id },
      })
    },
    limpar() {
      this.listaUsuarios = []
      this.totalPaginas = 0
    },
    retornaCamposTabela() {
      return {
        nome: {
          label: 'Nome',
        },
        email: {
          label: 'E-mail',
        },
        whatsapp: {
          label: 'Contato',
        },
      }
    },
    cadastroUsuario() {
      this.$router.push({ name: 'rota-usuarios-cadastro' })
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}

</script>
